import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CreatorsList from "@/pages/CreatorsList";
import CreatorProfile from "@/pages/CreatorProfile";
import CreatorDashboard from "@/pages/CreatorDashboard";
import CreatorUpload from "@/pages/CreatorUpload";
import BrandDashboard from "@/pages/BrandDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import BrandBook from "@/pages/BrandBook";
import PilotPage from "@/pages/PilotPage";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/pilot" element={<PilotPage />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route
                            path="/brand-book"
                            element={
                                <ProtectedRoute roles={["admin"]}>
                                    <BrandBook />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/marketplace" element={<Navigate to="/" replace />} />
                        <Route path="/creators" element={<CreatorsList />} />
                        <Route path="/creators/:id" element={<CreatorProfile />} />
                        <Route
                            path="/creator"
                            element={
                                <ProtectedRoute roles={["creator", "admin"]}>
                                    <CreatorDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/creator/upload"
                            element={
                                <ProtectedRoute roles={["creator", "admin"]}>
                                    <CreatorUpload />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/brand"
                            element={
                                <ProtectedRoute roles={["brand", "admin"]}>
                                    <BrandDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute roles={["admin"]}>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
